<script lang="ts">
	import type { Collection, Element, GameArray } from '../utils/types';
	import Passive from './Elements/Passive.svelte';
	import { fade, fly } from 'svelte/transition';
	import Active from './Elements/Active.svelte';
	import LightningBar from '../components/LightningBar.svelte';
	import Variant from './Elements/Variant.svelte';

	export let index: number;
	export let collection: Collection;
	export let gameArray: GameArray;
	export let mousedown: (index: number) => void;
	export let onmouseout: (hoverState: boolean) => void;
	export let onmouseover: (index1: number, index2: number, x: number, y: number) => void;
	export let isItemSymemtrical: (array: GameArray, element: Element) => boolean = null;
	export let changeVariantElement: () => void = null;
	export let winState: () => void = null;
</script>

{#each collection.items as element}
	{#if collection.type === 'ACTIVE'}
		<Active
			{collection}
			{element}
			shapeIndex={index}
			{mousedown}
			{onmouseout}
			{onmouseover}
			isItemSymemtrical={() => isItemSymemtrical(gameArray, element)}
			{changeVariantElement}
			{winState}
		/>
	{:else if collection.type === 'PASSIVE'}
		<Passive
			{collection}
			{element}
			{mousedown}
			{onmouseout}
			{onmouseover}
			isItemSymemtrical={() => isItemSymemtrical(gameArray, element)}
			{changeVariantElement}
		/>
	{:else if collection.type === 'VARIANT'}
		<Variant
			{collection}
			{element}
			shapeIndex={index}
			{mousedown}
			{onmouseout}
			{onmouseover}
			isItemSymemtrical={() => isItemSymemtrical(gameArray, element)}
			{changeVariantElement}
		/>
	{/if}
{/each}

<!-- on:mouseover={() => onMouseover(point.xpos, point.ypos)} -->
